export const PAGE_PATH = '/fortuna/admin/list';
